/**
 * Tool registry — maps the store's `ToolKind` to a live Tool instance.
 *
 * One registry per canvas mount. Each tool instance keeps its own state
 * (in-progress stroke, move delta, etc.) so swapping tools is just
 * "cancel the old one, point at the new one".
 *
 * `text` is deliberately missing for Stage D — the text tool needs a
 * contenteditable overlay which I'll handle in Stage D.7 if there's time,
 * otherwise it lands in Stage G alongside image overlays.
 */

import type { ToolKind } from "../store/sceneStore";
import type { Tool } from "./tool";
import { PenTool } from "./penTool";
import { ShapeTool } from "./shapeTool";
import { SelectTool } from "./selectTool";

export function createToolRegistry(): Record<ToolKind, Tool> {
  return {
    select: new SelectTool(),
    pen: new PenTool(),
    rect: new ShapeTool("rect"),
    ellipse: new ShapeTool("ellipse"),
    line: new ShapeTool("line"),
    arrow: new ShapeTool("arrow"),
    // Placeholder: text tool is not implemented yet. Selecting it behaves
    // like select (inert) so the palette button doesn't break the canvas.
    text: new SelectTool(),
  };
}
